// Alert helpers for server-rendered fragments.
//
// Alerts are often delivered by htmx responses as out-of-band fragments into a
// shell-level stack. The component remains plain HTML; this module only wires
// close buttons so swapped-in alerts can be dismissed without app-specific JS.

import { $$, on } from './util';

const CLOSE_SELECTOR = '[data-bf-dismiss="alert"], .bf-alert__close';

export function init(root: ParentNode = document): void {
  for (const close of $$<HTMLElement>(CLOSE_SELECTOR, root)) {
    if (close.dataset.bfAlertBound === 'true') continue;
    close.dataset.bfAlertBound = 'true';
    on(close, 'click', (event) => {
      const alert = close.closest<HTMLElement>('.bf-alert');
      if (!alert) return;
      event.preventDefault();
      alert.remove();
    });
  }
}
